'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "RollupActivator": "Polaris-ActionMenu-RollupActions__RollupActivator"
};

exports.default = styles;
